// extracted by mini-css-extract-plugin
export default {"agritourismL1":"AgritourismL1_agritourismL1__TX-e7","cards":"AgritourismL1_cards__jdEmM","bigcard":"AgritourismL1_bigcard__kXATc","map":"AgritourismL1_map__dyY9A"};